import { UpdateAlexaSkillsQueryArg } from '../types/query-arg';
import { UpdateAlexaSkillsQueryBody } from '../types/query-body';

export const updateAlexaSkillsQueryBody = ({
  organisation,
  alexaSkills,
}: UpdateAlexaSkillsQueryArg): UpdateAlexaSkillsQueryBody => ({
  organisationId: organisation.id,
  alexaSkills,
});
